import React from "react";
import "./Footer.css";

// MUI Icons
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* About */}
        <div className="footer-section">
          <h3>Mapesa Foundation</h3>
          <p>
            Empowering youth, uplifting communities, and driving sustainable
            change in South Africa.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li>
              <a href="/#home">Home</a>
            </li>
            <li>
              <a href="/#about">About</a>
            </li>
            <li>
              <a href="/#programs">Programs</a>
            </li>
            <li>
              <a href="/#impact">Impact</a>
            </li>
            <li>
              <a href="/contact">Contact</a>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section">
          <h3>Contact Info</h3>
          <p>
            <LocationOnIcon /> 107 Haymeadow Street, Boardwalk Office Park,
            Pretoria, 0400
          </p>
          <p>
            <PhoneIcon /> (+27) 72 514 5964
          </p>
          <p>
            <EmailIcon /> admin@mapesa.co.za
          </p>
        </div>

        {/* Social Media */}
        <div className="footer-section">
          <h3>Follow Us</h3>
          <div className="footer-socials">
            <a
              href="https://www.facebook.com/mapesafoundation"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FacebookIcon />
            </a>

            <a
              href="https://www.instagram.com/mapesa.foundation.za"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <InstagramIcon />
            </a>

            {/* <a
              href="https://twitter.com/mapesafoundation"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
            >
              <TwitterIcon />
            </a> */}

            <a
              href="https://wa.me/27725145964"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
            >
              <WhatsAppIcon />
            </a>
          </div>
        </div>
      </div>

      <p className="footer-bottom">
        © 2025 Mapesa Foundation. All Rights Reserved.
      </p>
    </footer>
  );
};

export default Footer;
